var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.29644 14.1841C8.78253 13.6975 9.35978 13.3114 9.99516 13.048C10.6306 12.7846 11.3116 12.6491 11.9994 12.6491C12.6873 12.6491 13.3683 12.7846 14.0037 13.048C14.6391 13.3114 15.2163 13.6975 15.7024 14.1841M5.52344 11.4101C7.24118 9.69291 9.57059 8.72827 11.9994 8.72827C14.4283 8.72827 16.7577 9.69291 18.4754 11.4101M13.3074 17.8861C13.3074 18.233 13.1696 18.5657 12.9243 18.811C12.679 19.0563 12.3463 19.1941 11.9994 19.1941C11.6525 19.1941 11.3198 19.0563 11.0745 18.811C10.8292 18.5657 10.6914 18.233 10.6914 17.8861C10.6914 17.5392 10.8292 17.2065 11.0745 16.9612C11.3198 16.7159 11.6525 16.5781 11.9994 16.5781C12.3463 16.5781 12.679 16.7159 12.9243 16.9612C13.1696 17.2065 13.3074 17.5392 13.3074 17.8861Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 8.63602C5.20345 6.18314 8.5307 4.80518 12 4.80518C15.4693 4.80518 18.7965 6.18314 21.25 8.63602",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.57b1a3ac925358487b4d27b5a7854adf.svg";
export { ForwardRef as ReactComponent };